import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {PacienteService} from '../paciente.service';
import {PatientView} from '../paciente.classes';
import {Subscription} from "rxjs/Subscription";
import { CatalogosService } from 'app/shared/services/catalogos.service';
import {environment} from "environments/environment";
import { NivelesCovid, NivelesGlu, NivelesPA, NivelesPeso } from 'app/shared/classes/common.classes';
import { log } from 'console';
import { NotificationService } from 'app/shared/utils/notification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthNioService } from 'app/+login-nio/auth-nio.service';


@Component({
    selector: 'app-paciente-ficha-layout',
    templateUrl: './paciente.ficha.layout.html',
    styleUrls: ['./paciente.ficha.layout.css']
})
export class PacienteFichaLayout implements OnInit, OnDestroy {
    @Input() paciente: PatientView | string;
    // En donde se requiera nowPaciente voy a emplear patient details.

    patientDetails: PatientView = new PatientView();
    patientAge: number;
    pacti :PatientView = new PatientView();
    tutor:boolean;
    subscriptions: Subscription = new Subscription();
    nombr:string;
    telef:string;
    email:string;
    paren:string;
    ServGLU:boolean= false;
    ServPA:boolean= false;
    ServPE:boolean= true;
    ServCOV:boolean= false;
    isAlentha:boolean=false;
    _idgroups : string ="";
    NivPeso: NivelesPeso= new NivelesPeso();  
    NivGlu: NivelesGlu= new NivelesGlu();
    NivCovid: NivelesCovid= new NivelesCovid();
    NivPA: NivelesPA = new NivelesPA();
    gen1;
    gen2;
    gen3;

    folio: string;
    sucursal: string;
    validado = false;
    cargando = false;
    mensajeError = '';
    safeUrl: SafeResourceUrl;

    constructor(public authservice: AuthNioService,private sanitizer: DomSanitizer,private catalogosService: CatalogosService,private pacienteService: PacienteService,private notificationService:NotificationService) {
    }

    ngOnInit() {

        var USERNAME =this.authservice.token.username;
        if(USERNAME !='DRCAMPA' && USERNAME !='MARISOL' && USERNAME !='CMARQUINEZ'){
            USERNAME ='DRBRAVO'
        }
        //const url = 'https://calendar.google.com/calendar/embed?src=telemedicinamx1%40gmail.com&ctz=America%2FMexico_City';
       var url = 'https://scheduler.zoom.us/medios-consulta-en-linea/'+USERNAME+'?embed=true';
       url='https://scheduler.zoom.us/carlos-marquinez/cmarquinez?embed=true'

      // console.log(url);

        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        
        // Patientview o IdPaciente
        if (this.paciente) {
            if (this.paciente instanceof PatientView) {
                    this.patientDetails = this.paciente;
                    this.cargarDatosPaciente();
            } else {
                
                    this.patientDetails.idPaciente = this.paciente;
                    this.cargarDatosPaciente();
            }
        }
        var seletedgroupd = localStorage.getItem('id_select_group');
        if(environment.Instance_file=='ECE'){
            this._idgroups='24';
        }else{
            this._idgroups='14';
        }
        if(seletedgroupd == this._idgroups){
            this.isAlentha=true;
        }


        const modalElement = document.getElementById('AGENDARCITA');
        if (modalElement) {
          modalElement.addEventListener('hidden.bs.modal', () => {
            this.resetModal();
          });
        }
    }

    cerrarModal(): void {
        this.resetModal();
        ($('#AGENDARCITA') as any).modal('hide'); // Cierra la modal manualmente
      }


    resetModal(): void {
        this.folio = '';
        this.sucursal = '';
        this.mensajeError = '';
        this.validado = false;
        this.cargando = false;
      }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }


    SendNiveles(TIPO){
        const dateTime = Date.now();
        if(TIPO=="GLUCOSA"){
            this.NivGlu = new NivelesGlu();
            this.NivGlu.glumedida=this.gen1;
            this.NivGlu.gluperiodo=9;
            this.NivGlu.pacidfk = this.patientDetails.idPaciente;
            this.NivGlu.medidfk="";
            this.NivGlu.glufechahora=dateTime.toString();
            this.pacienteService.setNIVGLU(this.NivGlu)
            .subscribe(
                (rest) => {
                   if(rest){
                    this.notificationService.smallBox({
                                title: 'NIVELES ENVIADOS CON EXITO',
                                content: '<br>',
                                color: "#739E73",
                                icon: "fa fa-check",
                                timeout: 3000
                            });
                            this.pacienteService.getNIVGLU(this.patientDetails.idPaciente)
                            .subscribe(
                                (NivGLU) => {
                                    
                                    var sds ="";
                                   //this.barras.Upload(10,this.TIPO,this.Glu);
                                },
                                () => {
                                    var sds ="";
                                   
                                }
                            ); 
                   }
                }, error => {
                    this.notificationService.smallBox({
                        title: 'ERROR',
                        content: 'ERROR AL INGRESAR NIVELES' +error.message.toString(),
                        color: '#ffc107',
                        icon: 'fa fa-warning shake',
                        timeout: 3000
                    });
                  
                }
            ); 

            
        }else if (TIPO=="PRESION ARTERIAL"){
            this.NivPA = new NivelesPA();
            this.NivPA.pasysmedida=this.gen1;
            this.NivPA.padiamedida=this.gen2;
            this.NivPA.pafcmedida=this.gen3;
            this.NivPA.paperiodo=9;
            this.NivPA.pacidfk = this.patientDetails.idPaciente;
            this.NivPA.medidfk="";
            this.NivPA.pafechahora=dateTime.toString();
       this.pacienteService.setNIVPA(this.NivPA)
            .subscribe(
                (rest) => {
                   if(rest){
                    this.notificationService.smallBox({
                                title: 'NIVELES ENVIADOS CON EXITO',
                                content: '<br>',
                                color: "#739E73",
                                icon: "fa fa-check",
                                timeout: 3000
                            });
                            this.pacienteService.getNIVPA(this.patientDetails.idPaciente)
                            .subscribe(
                                (NivPA) => {
                                    var sds ="";
                                },
                                () => {
                                    var sds ="";
                                   
                                }
                            );     
                   }
                }, error => {
                    this.notificationService.smallBox({
                        title: 'ERROR',
                        content: 'ERROR AL INGRESAR NIVELES' +error.message.toString(),
                        color: '#ffc107',
                        icon: 'fa fa-warning shake',
                        timeout: 3000
                    });
                  
                }
            ); 

        }else if (TIPO=="PESO"){
            this.NivPeso = new NivelesPeso();
            this.NivPeso.pesomedida=this.gen1;
            this.NivPeso.pesoperiodo=9;
            this.NivPeso.pacidfk = this.patientDetails.idPaciente;
            this.NivPeso.medidfk="";
            this.NivPeso.pesofechahora=dateTime.toString();
            this.pacienteService.setNIVPESO(this.NivPeso)
            .subscribe(
                (rest) => {
                   if(rest){
                    this.notificationService.smallBox({
                                title: 'NIVELES ENVIADOS CON EXITO',
                                content: '<br>',
                                color: "#739E73",
                                icon: "fa fa-check",
                                timeout: 3000
                            });
                            this.pacienteService.getNIVPESO(this.patientDetails.idPaciente)
                            .subscribe(
                                (NivPESO) => {
                                    var sds ="";
                                   
                                },
                                () => {
                                    var sds ="";
                                   
                                }
                            );    
                   }
                }, error => {
                    this.notificationService.smallBox({
                        title: 'ERROR',
                        content: 'ERROR AL INGRESAR NIVELES' +error.message.toString(),
                        color: '#ffc107',
                        icon: 'fa fa-warning shake',
                        timeout: 3000
                    });
                  
                }
            ); 
        }else if (TIPO=="SIGNOS VITALES"){
            this.NivCovid = new NivelesCovid();
            this.NivCovid.covidspomedida=this.gen1;
            this.NivCovid.covidpulsomedida=this.gen2;
            this.NivCovid.covidtempmedida=this.gen3;
            this.NivCovid.covidperiodo=9;
            this.NivCovid.pacidfk = this.patientDetails.idPaciente;
            this.NivCovid.medidfk="";
            this.NivCovid.covidfechahora=dateTime.toString();
            this.pacienteService.setNIVCOVID(this.NivCovid)
            .subscribe(
                (rest) => {
                   if(rest){
                    this.notificationService.smallBox({
                                title: 'NIVELES ENVIADOS CON EXITO',
                                content: '<br>',
                                color: "#739E73",
                                icon: "fa fa-check",
                                timeout: 3000
                            });
                           
                            this.pacienteService.getNIVCOVID(this.patientDetails.idPaciente)
                            .subscribe(
                                (NivCOVID) => {
                                    var sds ="";
                                },
                                () => {
                                    var sds ="";
                                   
                                }
                            ); 
                            
                   }
                }, error => {
                    this.notificationService.smallBox({
                        title: 'ERROR',
                        content: 'ERROR AL INGRESAR NIVELES' +error.message.toString(),
                        color: '#ffc107',
                        icon: 'fa fa-warning shake',
                        timeout: 3000
                    });
                  
                }
            ); 
        }

        this.gen1=0;
        this.gen2=0;
        this.gen3=0;
        document.getElementById("cancelarnivAll").click();

    }

    /**
     * Cargar los datos del paciente del REST paciente, si ya tiene el nombre quiere decir que tiene los demás datos
     * (incluidos datos clínicos), ya no o pidas por HTTP
     */
    cargarDatosPaciente() {
        if (!this.patientDetails.nombre && this.patientDetails.idPaciente) {
            this.subscriptions.add(
                this.pacienteService.getById(this.patientDetails.idPaciente)
                    .subscribe(patientView => {
                           if(patientView.catServiciosList){
                            patientView.catServiciosList.forEach(element => {
                                    switch(element.idCatServicio){
                                        case 1:
                                            this.ServCOV = true;
                                        break;
                                        case 2:
                                            this.ServGLU = true;
                                        break;
                                        case 3:
                                            this.ServPE = true;
                                        break;
                                        case 4:
                                            this.ServPA = true;
                                        break;
                                    }

                                });
                            }
                            this.tutor = patientView.es_titular;
                        if (!patientView.idPaciente) return;

                        if (patientView.idPaciente == this.patientDetails.idPaciente) {
                            this.patientDetails = patientView;
                            // if (this.patientDetails.fechaNacimiento.valueOf() < 0) { // less than 1970
                            //     let newFechaNacimiento: string = this.patientDetails.fechaNacimiento.valueOf().toString();
                            //     while (newFechaNacimiento.length < 13) { // 13 for milliseconds (with negative symbol -)
                            //         newFechaNacimiento += "0";
                            //     }
                            //     this.patientDetails.fechaNacimiento = new Date(parseInt(newFechaNacimiento));
                            // }
                            this.patientAge = Math.abs(new Date(Date.now() - new Date(this.patientDetails.fechaNacimiento).getTime()).getUTCFullYear() - 1970);
                            // @ts-ignore
                            this.pacienteService.pacienteActual = this.patientDetails;
                            if(!this.tutor){
                                this.catalogosService.GETRELtutores(patientView.idPaciente).subscribe(rt=>{
                                    console.log("dentro del ficha layout rt");
                                    console.log(rt);
                                    console.log("FUERA del ficha layout rt");

                                    this.nombr=rt.nombreTutor;
                                    this.telef=rt.telefono;
                                    this.email=rt.email;
                                    this.paren=rt.parentesco;
                                });
                            }

                        }
                    })
            );
        } else {
            this.patientAge = new Date(Date.now() - new Date(this.patientDetails.fechaNacimiento).getTime()).getFullYear();
        }
    }


    // UNEFARM

    
        // nuevaConsultaRAPIDA({imprimirReferencia = false}: { imprimirReferencia: boolean }): void {
        //     this.trySave = true;
    
        //     if (this.cargando) {
        //         return;
        //     }
    
        //     Object.keys(this.frmNuevaConsulta.controls).forEach(key => {
        //         this.frmNuevaConsulta.get(key).markAsDirty();
        //         this.frmNuevaConsulta.get(key).updateValueAndValidity();
        //     });
    
           
        //     console.log(this.frmNuevaConsulta);
        //     console.log(this.modelo.fechaConsulta);
    
        //     if(this.modelo.fechaConsulta === undefined){
                
        //         this.modelo.fechaConsulta = new Date();
        //         this.modelo.fechaConsultaFin = new Date();
        //     }
    
        //     if (
        //         this.selectedPaciente.idPaciente !==undefined
        //     ) {
        //         this.modelo.creadoPor = this.usuarioServicio.fullName;
        //         this.modelo.tipoConsulta = this.selectedType.descripcion;
        //         this.modelo.fechaCrecion = new Date();
        //         this.modelo.idPaciente = this.selectedPaciente.idPaciente;
        //         this.modelo.nombrePaciente = `${this.selectedPaciente.nombre ? this.selectedPaciente.nombre : ''} ${this.selectedPaciente.apellidoPaterno ? this.selectedPaciente.apellidoPaterno : ''} ${this.selectedPaciente.apellidoMaterno ? this.selectedPaciente.apellidoMaterno : ''}`;
        //         this.modelo.fechaInicio = null;
        //         this.modelo.feachaFin = null;
        //         this.modelo.numeroConsulta = '' + Math.floor(Math.random() * 900000000);
        //         this.modelo.canal = this.selectedCanal.descripcion;
    
        //         this.modelo.motivoConsulta = this.model.motivoConsulta;
        //         this.modelo.idMedico = this.usuarioServicio.usersDetails.idMedico;
        //         this.modelo.especialidad = this.medicoLogueado.especialidadViewList[0].especialidad;
        //         this.modelo.listaPadecimiento = this.ailmentsSelected;
        //         this.modelo.idTipoConsulta = this.selectedType.id;
        //         this.modelo.nombreMedico = this.usuarioServicio.usersDetails.fullName ? this.usuarioServicio.usersDetails.fullName : `${this.usuarioServicio.usersDetails.nombre ? this.usuarioServicio.usersDetails.nombre : ''} ${this.usuarioServicio.usersDetails.apellidoPaterno ? this.usuarioServicio.usersDetails.apellidoPaterno : ''} ${this.usuarioServicio.usersDetails.apellidoMaterno ? this.usuarioServicio.usersDetails.apellidoMaterno : ''}`;
        //         if (this.selectedMedic.idMedico) {
        //             this.modelo.idMedicoSolicitado = this.selectedMedic.idMedico;
        //             this.modelo.nombreMedicoSolicitado = this.selectedMedic.fullName ? this.selectedMedic.fullName : this.selectedMedic.nombre;
        //             if (this.selectedMedic.especialidadViewList.length) {
        //                 this.modelo.especialidadMedicoSolicitado = this.selectedMedic.especialidadViewList[0].especialidad;
        //             } else {
        //                 this.modelo.especialidadMedicoSolicitado = 'MEDICINA GENERAL';
        //             }
    
        //         }
               
    
        //         this.modelo.signosVitales = this.signosVitales;
    
    
        //         this.cargando = true;
        //         console.log(this.modelo);
        //         this.consultaService.getEstadoConsultaActual(1)
        //             .subscribe((estadoConsultaActual: CatEstadoConsultaView) => {
        //                 this.modelo.estadoConsulta = estadoConsultaActual.descripcion;
        //                 this.modelo.idEstadoConsulta = estadoConsultaActual.idEstadoConsulta;
        //                 this.modelo.idGroup = this.idselectedGroup;
        //                 this.consultaService.save(this.modelo)
        //                     .subscribe((savedConsultaEvent) => {
        //                         setTimeout(() => {
        //                             if (imprimirReferencia && savedConsultaEvent && savedConsultaEvent.idConsulta) {
        //                                 this.printReference(savedConsultaEvent.idConsulta);
        //                                 (<any>$('#newConsulta')).modal('hide');
        //                                 this.refreshTable();
        //                                 this.resetlista(); // GGR 20200518
        //                                 this.notificationService.smallBoxSuccess({
        //                                        title: 'Exito',
        //                                         content: 'Consulta creada',
        //                                         color: '#22bb33',
        //                                         icon: 'fa fa-check',
        //                                         timeout: 3000
        //                                 });
        //                                 this.cargando = false;
        //                                 this.onConsultaAdded.emit({error: false});
        //                             } else {
        //                                 this.resetlista(); // GGR 20200518
        //                                 this.notificationService.smallBoxSuccess({
        //                                         title: 'Exito',
        //                                          content: 'Consulta creada',
        //                                          color: '#22bb33',
        //                                          icon: 'fa fa-check',
        //                                          timeout: 3000
        //                                  });
        //                                 (<any>$('#newConsulta')).modal('hide');
        //                                 this.refreshTable();
        //                                 this.cargando = false;
        //                                 this.onConsultaAdded.emit({error: false});
        //                                 let startD: Date, endD: Date;
        //                                 startD = this.fechasFiltro[0];
        //                                 startD.setHours(0, 0, 0, 0);
        //                                 endD = this.fechasFiltro[1];
        //                                 endD.setHours(23, 59, 59, 99);
        //                                 let options: NiomedicPageRequest = new NiomedicPageRequest;
        //                                     options.startDate = startD.getTime();
        //                                     options.endDate = endD.getTime();
        //                                     options.page = 0;
        //                                     options.size = 1000;
        //                                     options.orderColumn = 'fechaConsulta';
        //                                     options.orderType = 'desc';
        //                                     options.idMedico = this.modelo.idMedico;
        //                                     options.idPaciente = this.modelo.idPaciente;
    
        //                                 this.consultaService.getPage(options)
        //                                 .subscribe((pageConsultaView) => {
        //                                     this.onlyConsultas = pageConsultaView.content;
        //                                     console.log("entro only");
        //                                     console.log(this.onlyConsultas);
        //                                     for(var x=0;x<=this.onlyConsultas.length;x++){
        //                                         console.log(this.onlyConsultas[x]);
        //                                         if(this.onlyConsultas[x]['idEstadoConsulta']==1){
        //                                             this.consu = this.onlyConsultas[x];
        //                                             break;
        //                                         }
        //                                     }
                                           
        //                                     this.consultaStartAndGo(this.consu);
    
        //                                 });
    
    
        //                             }
        //                         });
        //                     }, (error) => {
        //                         console.log("EROR");
        //                         this.cargando = false;
        //                         this.onConsultaAdded.emit({error: true});
        //                         this.notificationService.bigBox({
        //                             title: 'Error al guardar la consulta',
        //                             content: `No se pudo guardar la consulta ${JSON.stringify(error)}`,
        //                             color: '#C46A69',
        //                             icon: 'fa fa-warning',
        //                             timeout: 6000
        //                         });
        //                     }, () => {
        //                         this.cargando = false;
        //                     });
        //             });
        //     }
        // }

    validarFolio() {
      this.mensajeError = '';

      if (!this.folio || !this.sucursal) {
        this.mensajeError = 'Debes ingresar sucursal y número de folio.';
        return;
      }

      this.cargando = true;

      this.pacienteService.getControlPagos(this.folio, this.sucursal)
        .subscribe({
          next: (resp) => {
            this.cargando = false;

            if (resp.estatusFolio ==1) { // Ajusta según cómo responde tu API
              this.validado = true;
              this.folio = '';
              this.sucursal = '';

            } else {
                switch(resp.estatusFolio){
                    case 0:
                        this.mensajeError ='EL FOLIO ESTA CANCELADO';
                    break;
                    case 2:
                        this.mensajeError ='EL FOLIO ESTA EN PROCESO DE ATENCION';
                    break;
                    case 3:
                        this.mensajeError ='EL FOLIO FUE ATENDIDO';
                    break;
                    default:
                        this.mensajeError ='FOLIO INCORRECTO';
                    break;
                }
                this.folio = '';
                this.sucursal = '';
            }
          },
          error: () => {
            this.cargando = false;
            this.mensajeError = 'ERROR AL VALIDAR EL FOLIO. INTENTA NUEVAMENTE.';
            this.folio = '';
            this.sucursal = '';
          }
        });
    }


}
